export default {
    colors: {
        gray: '#81818c',
        lightGray: '#c8c8cb',
        darkGray: '#2b2b32',
        backgroundWhite: '#E5E5E5',
        whiteSmoke: '#ebeced',
        white: '#ffffff',
        orange: '#fc9d2c',
        darkGreen: '#005857',
        lightGreen: '#e0F7F7',
        lighterDarkGreen: '#e6efef',
        black: '#000000',
        darkBlue: '#007a9e',
        red: '#a90821',
        purple: '#9e459a',
    },
};
